import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { descricaoMovel } from './fmt'

function formatCurrency(v) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0)
}

function formatDate(d) {
  if (!d) return '—'
  try { return format(new Date(d + 'T12:00:00'), "dd/MM/yyyy", { locale: ptBR }) } catch { return d }
}


function normalizarTelefone(contato) {
  const digits = (contato || '').replace(/\D/g, '')
  if (!digits) return null
  if (digits.startsWith('55') && digits.length >= 12) return digits
  if (digits.length >= 10) return '55' + digits
  return null
}

const FORMAS_LABEL = {
  pix:      'Pix',
  dinheiro: 'Dinheiro',
  credito:  'Cartão de crédito',
  debito:   'Cartão de débito',
}

const PRAZOS_LABEL = {
  ato:   'Tudo no ato do pedido',
  '50_50': '50% no pedido + 50% na entrega',
  custom:  null, // usa prazoPagamentoCustom
}

export function abrirWhatsApp(pedido) {
  const telefone = normalizarTelefone(pedido.cliente?.contato)

  const prazoLabel = pedido.prazoPagamento === 'custom'
    ? pedido.prazoPagamentoCustom || 'Personalizado'
    : PRAZOS_LABEL[pedido.prazoPagamento] || ''

  const formaPagLabel = FORMAS_LABEL[pedido.formaPagamento] || pedido.formaPagamento || ''

  const linhasMoveis = (pedido.moveis || []).map((m, i) => {
    const desc = descricaoMovel(m)
    return `  ${i + 1}. ${desc}\n     Valor: *${formatCurrency(m.preco)}*`
  }).join('\n\n')

  const mensagem = [
    `🪑 *MINI Marcenaria — Pedido ${pedido.numero}*`,
    '',
    `Olá, *${pedido.cliente?.nome?.split(' ')[0] || 'cliente'}*! 😊`,
    `Segue o resumo do seu pedido:`,
    '',
    `📋 *Resumo do pedido*`,
    `Nº: ${pedido.numero}`,
    `Data: ${formatDate(pedido.criadoEm?.split('T')[0])}`,
    `Prazo de entrega: *${formatDate(pedido.prazo)}*`,
    pedido.vendedora ? `Vendedora: ${pedido.vendedora}` : '',
    '',
    `🛋️ *Móveis*`,
    linhasMoveis,
    '',
    `💰 *Total: ${formatCurrency(pedido.valorTotal)}*`,
    formaPagLabel ? `Forma de pagamento: ${formaPagLabel}` : '',
    prazoLabel    ? `Condição: ${prazoLabel}` : '',
    pedido.observacoesGerais ? `\n📝 Obs: ${pedido.observacoesGerais}` : '',
    '',
    `_Obrigado pela preferência! 🙏_`,
    `_Mini Marcenaria_`,
  ].filter(l => l !== null).join('\n')

  const url = telefone
    ? `https://wa.me/${telefone}?text=${encodeURIComponent(mensagem)}`
    : `https://wa.me/?text=${encodeURIComponent(mensagem)}`

  window.open(url, '_blank', 'noopener,noreferrer')
}
